import React, { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Deal from '../../../../Components/Hands/Deal/Deal.js';
import Auction from '../../../../Components/Hands/Auction.js';
import Contract from '../../../../Components/Hands/Contract/Contract.js';
import CompleteButtons from './CompleteButtons.js';
import { useTranslation } from 'react-i18next';
import { formatComment } from '../../../../helpers/comment.js';
import { useOrientation } from '../../../../Hooks';
import { HandContext } from '../../../../Context/HandContext.js';

const useStyles = makeStyles((theme) => ({
  column: {
    padding: '1rem',
    height: 'calc(86vh - 50px)',
    '@media all and (max-height: 667px)': {
      height: 'calc(90vh - 50px)'
    }
  },
  paper: {
    background: 'rgba(0,0,0,0.2)',
    border: '1px solid rgba(255,255,255,0.25)',
    padding: theme.spacing(2)
  },
  paperPortrait: {
    background: 'transparent',
    border: 'none',
    padding: 0
  },
  dealContainer: {
    fontSize: '0.7rem',
    [theme.breakpoints.up('lg')]: {
      fontSize: '1rem'
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '1.3rem'
    },
    [theme.breakpoints.up(1800)]: {
      fontSize: '1.5rem'
    }
  },
  auction: {
    color: '#fff',
    '& table': {
      fontSize: '1rem'
    }
  },
  summaryContainer: {
    background: '#fff',
    borderRadius: '1rem',
    margin: '1rem',
    padding: '2rem',
    flexGrow: 1,
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
    width: '90%'
  },
  summary: {
    overflow: 'hidden',
    overflowY: 'auto',
    '& p': {
      margin: 0
    }
  }
}));

export default function PlayComplete () {
  const { t } = useTranslation();
  const isPortrait = useOrientation();
  const { handJSON } = useContext(HandContext);

  const {
    deal,
    dealer,
    vulnerable,
    viewpoint,
    auction,
    playOnly,
    contract,
    declarer,
    summary
  } = handJSON;

  const classes = useStyles();

  return (
    <Grid
      container
      data-testid='play-complete'
      direction='row'
      justifyContent='center'
      alignItems='center'
    >
      <Grid item>
        <Grid
          container
          direction='column'
          justifyContent='center'
          alignItems='center'
        >
          <Grid item xs>
            <Grid
              container
              direction='column'
              justifyContent='center'
              alignItems='center'
              className={classes.column}
            >
              <Grid item>
                <Paper
                  className={clsx(classes.paper, isPortrait && classes.paperPortrait)}
                >
                  <Grid
                    container
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    spacing={isPortrait ? 1 : 4}
                  >
                    <Grid item className={classes.dealContainer}>
                      <Deal
                        selectable={false}
                        cards={deal}
                        dealer={dealer}
                        vulnerable={vulnerable}
                        viewpoint={viewpoint}
                        activeDirection='None'
                        wideLayout={isPortrait}
                        wrap={isPortrait}
                        allPlayed
                      />
                    </Grid>
                    <Grid item className={classes.auction}>
                      {
                        playOnly
                          ? <div><Contract contract={contract} declarer={declarer} /></div>
                          : <Auction auction={auction} dealer={dealer} isPortrait={isPortrait} />
                      }
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              {
                isPortrait && (
                  <Grid item className={classes.summaryContainer}>
                    <div
                      className={classes.summary}
                      dangerouslySetInnerHTML={
                        { __html: formatComment(summary, t) }
                      }
                    />
                  </Grid>
                )
              }
              <Grid item>
                <CompleteButtons />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
